function initNavSubMenus() {
    const subMenus = document.querySelectorAll('.nav-sub-menu');
    const subMenuBtns = document.querySelectorAll('.sub-menu-btn');

    document.addEventListener('click', (e) => {
        const subMenuBtn = e.target.closest('.sub-menu-btn');

        if (subMenuBtn) {
            const subMenuContainer = subMenuBtn.closest('.has-sub-menu');
            const subMenu = subMenuContainer.querySelector('.nav-sub-menu');

            if (!subMenuBtn.classList.contains('btn-active')) {
                closeAllSubMenus();
                subMenuBtn.classList.add('btn-active');
                subMenu.removeAttribute('inert');
            } else {
                closeAllSubMenus();
            }

        } else {
            document.querySelector('.sub-menu-btn.btn-active') && closeAllSubMenus();
        }
    });

    function closeAllSubMenus() {
        subMenuBtns.forEach(btn => {
            const subMenuContainer = btn.closest('.has-sub-menu');
            const subMenu = subMenuContainer.querySelector('.nav-sub-menu');
            btn.classList.remove('btn-active');
            subMenu.toggleAttribute('inert');
        });
    }

    /* close sub-menu when focus leaves the container */
    subMenus.forEach(subMenu => {
        subMenu.addEventListener('focusout', (e) => {
            if (!subMenu.contains(e.relatedTarget)) {
                closeAllSubMenus();
            }
        });
    });

}

export default initNavSubMenus;